import { Validator } from '@vista-digital/validator';
import { seatAppearanceConfigValidator } from './seat-appearance';
export const seatAppearanceStatesConfigValidator = Validator.object({
    default: seatAppearanceConfigValidator,
    selected: Validator.optional(seatAppearanceConfigValidator),
    unavailable: Validator.optional(seatAppearanceConfigValidator),
    house: Validator.optional(seatAppearanceConfigValidator)
});
//# sourceMappingURL=seat-appearance-states.js.map